import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'antd';
import { useMutation, useQueryClient } from 'react-query';
import { DeleteOutlined, SaveOutlined } from '@ant-design/icons';

import { postObsDatasetMessage, deleteObsDatasetMessage } from '../../../../services/dataset.service';
import MapQueryTypes from '../../../../services/query-types/map';

const PlatformMessage = (props) => {
  const { obsDatasetSummary } = props;

  const queryClient = useQueryClient();
  const [message, setMessage] = React.useState(obsDatasetSummary?.obs_dataset_message?.message || '');

  useEffect(() => {
    if (obsDatasetSummary?.obs_dataset_message?.message) {
      setMessage(obsDatasetSummary.obs_dataset_message.message);
    }
  }, [obsDatasetSummary]);

  const saveMessage = useMutation(
    (message) => postObsDatasetMessage(obsDatasetSummary.obs_dataset_id, message),
    {
      onSettled: () => {
        queryClient.invalidateQueries(MapQueryTypes.REST_OBS_DATASET_SUMMARIES_DATASET_DETAIL);
        queryClient.invalidateQueries(MapQueryTypes.REST_OBS_DATASET_SUMMARIES);
        // TODO: use the same cache key for summaries everywhere?
      },
    },
  );

  const clearMessage = useMutation(
    () => deleteObsDatasetMessage(obsDatasetSummary.obs_dataset_id, obsDatasetSummary?.obs_dataset_message?.obs_dataset_messages_id),
    {
      onSettled: () => {
        queryClient.invalidateQueries(MapQueryTypes.REST_OBS_DATASET_SUMMARIES_DATASET_DETAIL);
        queryClient.invalidateQueries(MapQueryTypes.REST_OBS_DATASET_SUMMARIES);
      },
    },
  );

  const onChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSave = () => {
    if (message.trim()) {
      saveMessage.mutate(message);
    }
  };

  const handleClear = () => {
    setMessage('');
    clearMessage.mutate();
  };

  return (
    <Card
    // variant="borderless"
      bordered={false}
      title="Platform Message"
      style={{
        backgroundColor: '#03304b', // TODO: replace with brand var
        border: '1px solid #4f6f81',
        color: 'white',
      }}
    >
      <textarea
        value={message}
        onChange={onChange}
        className="platform-message-textarea"
      />
      <div className="action-buttons">
        <Button
          onClick={handleClear}
          loading={clearMessage.isLoading}
          icon={<DeleteOutlined />}
          className="action-button"
        >
          Clear
        </Button>
        <Button
          icon={<SaveOutlined />}
          className="action-button"
          onClick={handleSave}
          loading={saveMessage.isLoading}
        >
          Save
        </Button>
      </div>
    </Card>
  );
};

PlatformMessage.propTypes = {
  obsDatasetSummary: PropTypes.object,
};

PlatformMessage.defaultProps = {
  obsDatasetSummary: {},
};

export default PlatformMessage;
